<template>
    <section v-if="isContentReady">
        <div class="row">
            <div class="col-12">
                <job-service-step :loadData="loadData"></job-service-step>
            </div>
        </div>
        
        <div class="row" v-if="isShowHeader">
            <div class="col-12">
                <job-service-header :loadData="loadData">บริการตรวจ/หลังขาย</job-service-header>
            </div>
        </div>

        <div id="panelCustomer" class="row">
            <div class="col-12">
                <job-service-customer 
                    @carInfoReady="carInfoReady()"
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-service-customer>
            </div>
        </div>

        <div id="panelServiceList" class="row" v-if="isShowServiceList">
            <div class="col-12">
                <job-service-list
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-service-list>
            </div>
        </div>

        <div class="text-center" v-if="isOpenJobAvailable">
            <button class="btn btn-main" @click="openJob()">เปิดใบตรวจและบริการ</button>
        </div>
        <div class="text-center" v-if="jobState === $Constants.JOB_STATUS_PENDING">
            <button class="btn btn-green mr-1" @click="saveJob()">บันทึกใบงาน</button>
            <button class="btn btn-main mr-1" @click="closeJob()">ปิดงาน</button>
            <button class="btn btn-red ml-4" @click="cancelJob(loadData)">ยกเลิก</button>
        </div>
    </section>
</template>

<script>
import Helper from '@/resources/Helper';
import JobFormMixin from '@/components/job/JobForm';
import JobServiceStep from '@/components/job/service/Step';
import JobServiceHeader from '@/components/job/shared/Header';
import JobServiceCustomer from '@/components/job/shared/Customer';
import JobServiceList from '@/components/job/service/List';
import DBJob from '@/database/Job';

export default {
    mixins: [ JobFormMixin ],
    components: {
        JobServiceStep,
        JobServiceHeader,
        JobServiceCustomer,
        JobServiceList
    },
    data() {
        return {
            isContentReady: false,
            formType: this.$Constants.JOB_FORM_SERVICE,
            isShowHeader: false,
            isShowServiceList: false,
            isOpenJobAvailable: false,
            jobState: this.$Constants.JOB_STATUS_NEW,
            loadData: null,
            errorData: null
        }
    },
    mounted() {
        this.initForm();
        this.initErrorData();
    },
    methods: {
        async initForm() {
            const queryStringOrder = Helper.getQueryString('o');

            if (queryStringOrder) {
                const data = await DBJob.getDetailByNumber(queryStringOrder, this.formType);

                if (data) {
                    this.isShowHeader = true;
                    this.isShowServiceList = true;
                    this.jobState = data.status;
                    this.loadData = data;
                } else {
                    this.$router.push('/404');
                }
            }

            this.isContentReady = true;
        },
        initErrorData() {
            this.errorData = {
                customer: {
                    licensePlate: { blank: false },
                    licensePlateProvince: { blank: false },
                    carBrand: { blank: false },
                    carModel: { blank: false },
                    distance: { blank: false },
                    picture: { blank: false },
                    customerFirstName: { blank: false },
                    customerLastName: { blank: false },
                    customerTel: { blank: false }
                },
                service: {
                    problemDetail: { blank: false }
                }
            };
        },
        carInfoReady() {
            this.isShowServiceList = true;
            this.isOpenJobAvailable = true;
        },
        openJob() {
            this.initErrorData();

            if (this.validateJob()) {
                this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_OPEN, this.formType);

                this.$router.push('/job/list');
            }
        },
        async saveJob() {
            this.initErrorData();

            if (this.validateJob()) {
                this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_UPDATE, this.formType);

                this.$swal({
                    title: 'บันทึกใบงานเรียบร้อยแล้ว',
                    icon: 'success'
                });
            }
        },
        closeJob() {
            this.initErrorData();

            if (this.validateJob()) {
                this.$swal({
                    title: 'งานเสร็จแล้วต้องการปิดใบตรวจและบริการ?',
                    text: 'โปรดยืนยันว่าต้องการปิดใบตรวจและบริการใบนี้',
                    icon: 'question',
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_CLOSE, this.formType);

                        this.$swal({
                            title: 'ปิดใบงานเรียบร้อยแล้ว',
                            icon: 'success',
                            confirmButtonText: 'กลับไปหน้ารายการ'
                        }).then(() => {
                            this.$router.push('/job/list');
                        });

                        this.jobState = this.$Constants.JOB_STATUS_COMPLETE;
                    }
                });
            }
        },
        cancelJob(data) {
            this.mixinsJobForm_CancelJob(data);
        },
        validateJob() {
            let valid = true;
            let isScrollDone = false;
            this.mixins_ResetScrollToError();

            if (!this.mixins_ValidateCustomer()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelCustomer');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateService()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelServiceList');
                    isScrollDone = true;
                }
            }

            return valid;
        }
    }
}
</script>